import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/infopages.scss";

function Privacy() {
  return (
    <div className="privacy">
      <Header />
      <main id="maincontent" className="page-main">
        <div className="page-title-wrapper">
          <h1 className="page-title"><span className="base">Privacy Policy</span></h1>
        </div>
        <div className="columns"><div className="column main">
          <p>Last updated: 8 September 2026</p>
          <p>This policy describes how hetcratehub collects, uses, shares, and protects personal information when you visit hetcratehub.today, contact us, or place an order.</p>

          <h4>1. Information we collect</h4>
          <ul>
            <li>Identity and contact information, including your name, email, telephone number, delivery address, and billing address.</li>
            <li>Order information, including products, amounts, fulfilment status, returns, and customer-service messages.</li>
            <li>Payment-related information processed by our payment providers. We do not ask you to send complete card details by email.</li>
            <li>Technical and usage information, such as IP address, browser type, device information, referring page, and interactions with the site.</li>
            <li>Preferences and communications you choose to provide.</li>
          </ul>

          <h4>2. How we use information</h4>
          <p>We use personal information to operate the store, process and deliver orders, provide support, prevent fraud, maintain security, comply with legal and accounting duties, improve the site, and send marketing only where permitted.</p>

          <h4>3. Legal grounds</h4>
          <p>Depending on the circumstances, processing may be necessary to perform a contract with you, meet a legal obligation, pursue a legitimate business interest that does not override your rights, or act on your consent.</p>

          <h4>4. When information is shared</h4>
          <p>We may share only the information needed with providers that support payment processing, hosting, security, analytics, customer support, parcel delivery, and professional advice. We may also disclose information when required by law, to protect rights and safety, or in connection with a business reorganisation. We do not sell personal information for money.</p>

          <h4>5. International processing</h4>
          <p>Some providers may process information outside your country. Where required, we use recognised safeguards and assess providers before sharing personal information.</p>

          <h4>6. Retention</h4>
          <p>We keep information only as long as reasonably needed for the purpose collected, including fulfilment, support, fraud prevention, tax, accounting, dispute, and legal requirements. Retention periods differ by record type.</p>

          <h4>7. Security</h4>
          <p>We use reasonable administrative, technical, and organisational safeguards. No internet service is completely secure, so please use a strong password where accounts are available and contact us if you suspect unauthorised activity.</p>

          <h4>8. Your choices and rights</h4>
          <p>Subject to applicable law, you may ask to access, correct, delete, restrict, or receive a copy of your personal information, object to certain processing, or withdraw consent. You may unsubscribe from marketing using the message link or by contacting us. We may need to verify your identity before completing a request.</p>

          <h4>9. Cookies</h4>
          <p>We use cookies and similar technologies for site operation, preferences, measurement, and—where enabled—marketing. Read the separate <a href="/cookies">Cookie Policy</a> for categories and controls.</p>

          <h4>10. Children</h4>
          <p>The store is intended for adults and is not directed to children. We do not knowingly collect personal information from children without the permission required by applicable law.</p>

          <h4>11. Policy changes</h4>
          <p>We may update this policy when our practices or legal requirements change. The revised date at the top identifies the latest version.</p>

          <h4>12. Contact</h4>
          <p>For privacy questions or requests, contact <a href="mailto:group@hetcratehub.today">group@hetcratehub.today</a>.</p>
          <p><strong>Mailing address</strong><br />23 Wharf Street, London, England, SE8 3GG UK</p>
        </div></div>
      </main>
      <Footer />
    </div>
  );
}

export default Privacy;
